import React, { useState } from "react";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
} from "./popover";
import { Button } from "./button";
import { Command, CommandInput, CommandItem, CommandList } from "./command";
import { Checkbox } from "./checkbox";
import { Check, ChevronDown } from "lucide-react";

export default function MultiSelectCombobox({
                                                options,
                                                selected,
                                                onChange,
                                                placeholder = "Select...",
                                            }) {
    const [open, setOpen] = useState(false);

    const toggle = (value) => {
        if (selected.includes(value)) {
            onChange(selected.filter((v) => v !== value));
        } else {
            onChange([...selected, value]);
        }
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    className="w-48 justify-between"
                >
                    {selected.length > 0
                        ? `${selected.length} selected`
                        : placeholder}
                    <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="bg-gray-100 text-black shadow-md border border-gray-300 z-50">
                <Command>
                    <CommandInput placeholder="Search..." />
                    <CommandList className="max-h-60 overflow-y-auto">
                        {options.map((option) => (
                            <CommandItem
                                key={option.value}
                                onSelect={() => toggle(option.value)}
                                className="cursor-pointer flex justify-between"
                            >
                                <div className="flex items-center space-x-2">
                                    <Checkbox
                                        checked={selected.includes(option.value)}
                                        onCheckedChange={() => toggle(option.value)}
                                    />
                                    <span>{option.label}</span>
                                </div>
                                {selected.includes(option.value) && <Check size={16} />}
                            </CommandItem>
                        ))}
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
